"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingFormulaInputVerb = exports.pricingFormulaInputAmountFormatted = exports.pricingFormulaInputValueFormatted = exports.pricingFormulatInputValue = exports.pricingFormulatInputTitle = exports.pricingFormulaInputDeserialize = exports.pricingFormulaInputVisibleToAdmins = exports.pricingFormulaInputAll = void 0;
const round_1 = __importDefault(require("lodash/round"));
const formatCurrency_1 = __importDefault(require("../util/formatCurrency"));
exports.pricingFormulaInputAll = ['CHARGE', 'MILES', 'MINUTES', 'TIP', 'REVENUE'];
exports.pricingFormulaInputVisibleToAdmins = ['CHARGE', 'MILES', 'MINUTES', 'TIP'];
function pricingFormulaInputDeserialize(value) {
    if (!exports.pricingFormulaInputAll.includes(value))
        throw new Error('Not a valid PricingFormulaInput');
    return value;
}
exports.pricingFormulaInputDeserialize = pricingFormulaInputDeserialize;
function pricingFormulatInputTitle(input) {
    switch (input) {
        case 'CHARGE':
            return 'Charge';
        case 'MILES':
            return 'Miles';
        case 'MINUTES':
            return 'Minutes';
        case 'TIP':
            return 'Tip';
        case 'REVENUE':
            return 'Revenue';
        default:
            throw new Error(`Unhandled PricingFormulaInput case "${input}"`);
    }
}
exports.pricingFormulatInputTitle = pricingFormulatInputTitle;
function pricingFormulatInputValue(input, charge, miles, minutes, tip, revenue) {
    switch (input) {
        case 'CHARGE':
            return charge;
        case 'MILES':
            return miles;
        case 'MINUTES':
            return minutes;
        case 'TIP':
            return tip;
        case 'REVENUE':
            return revenue;
        default:
            throw new Error(`Unhandled pricing formula input type '${input}'`);
    }
}
exports.pricingFormulatInputValue = pricingFormulatInputValue;
function pricingFormulaInputValueFormatted(input, value) {
    switch (input) {
        case 'CHARGE':
        case 'REVENUE':
        case 'TIP':
            return (0, formatCurrency_1.default)(value);
        case 'MILES':
            return `${roundedString(value)} mi`;
        case 'MINUTES':
            return `${roundedString(value)} min`;
    }
}
exports.pricingFormulaInputValueFormatted = pricingFormulaInputValueFormatted;
function pricingFormulaInputAmountFormatted(input, amount) {
    switch (input) {
        case 'CHARGE':
        case 'REVENUE':
        case 'TIP':
            return `${amount * 100}%`;
        case 'MILES':
        case 'MINUTES':
            return (0, formatCurrency_1.default)(amount);
    }
}
exports.pricingFormulaInputAmountFormatted = pricingFormulaInputAmountFormatted;
function roundedString(number) {
    const rounded = (0, round_1.default)(number, 2);
    return `${rounded === number ? '' : '~'}${rounded}`;
}
function pricingFormulaInputVerb(input) {
    switch (input) {
        case 'MILES':
        case 'MINUTES':
            return 'are';
        default:
            return 'is';
    }
}
exports.pricingFormulaInputVerb = pricingFormulaInputVerb;
